import React, { useEffect } from 'react'
import BreadCrumb from '../../utilities/BreadCrumb'
import SelectionBox from '../../audiences/render-helpers/selection-box';
import { resetStorage, setApexStorage, setCountryStorage, setEnterpriseLogo } from '../common';
import { goto } from '../../utilities/customRoutes';
import { connect } from "react-redux";
import { getUserProfile } from '../../../redux/settings/all-users/all-users.actions';
import { config } from '../../../helpers';

function Commercials(props) {
    const { userProfile } = props;

    useEffect(() => {
        resetStorage()
        setEnterpriseLogo()
        props.getUserProfile()

    }, [])

    let borderColor = "#89324c";
    const handleClick = value => {
        setApexStorage(value)
        setCountryStorage(props?.user?.timeZone === "Pacific/Auckland" ? "NZ" : 'AU')
        setEnterpriseLogo()

        goto("commercials/rates")
    }
    return (
        userProfile && <>
            <BreadCrumb checkDeep={false} name="Commercials" />
            <div className="d-flex flex-column justify-content-center m-3 mt-5 ">
                <div className='d-flex flex-row justify-content-center'>                    
                    {userProfile.turnOnNotification ? <div style={{ width: "125px" }}></div> : null}
                    <h4 className="text-center mt-sm-5 mb-5 font-italic typing-effect">Select desired commercial model</h4>
                </div>
                <div className="d-flex flex-row justify-content-center flex-wrap mb-sm-5">
                    {config.commbank ? <>
                        <SelectionBox color={borderColor} desc="BigAds Provides Self-Serve Platform & Media" name="Unified"
                            caption="Volume Rewards"
                            className="bb-animate fadeIn"
                            noInfo={true}
                            onClick={() => handleClick("unified-rewards")} isReady={true} />

                        <SelectionBox color={borderColor} desc="BigAds Provides Self-Serve Platform & Media" name="Unified"
                            caption="Volume Discount"
                            className="bb-animate fadeIn"
                            noInfo={true}
                            onClick={() => handleClick("unified-discount")} isReady={true} />
                    </> : <>

                    {userProfile.turnOnNotification ?
                        <div className='d-flex align-items-cener selection-box-unified-container'>
                            <ul className="selection-drop-menu">
                                <li className="selection-drop-item">
                                    <span onClick={() => handleClick("unified-rewards")} className="selection-item--1">Volume Rewards</span>
                                </li>
                                <li className="selection-drop-item">
                                    <span onClick={() => handleClick("unified-discount")} className="selection-item--2">Volume Discount</span>
                                </li>
                            </ul>
                            <SelectionBox color={borderColor} desc="BigAds Provides Self-Serve Platform & Media" name="Unified"
                                caption="Redeem Value"
                                className="selection-box-unified bb-animate fadeIn"
                                noInfo={true}
                                onClick={() => { }}
                                isReady={true} />
                        </div>

                        : <>
                            <SelectionBox color={borderColor} desc="BigAds Provides Self-Serve Platform & Media" name="Unified"
                                caption="Volume Discount"
                                noInfo={true}
                                className="bb-animate fadeIn"                                
                                onClick={() => handleClick("unified-discount")} isReady={true} />

                        </>}

                    <SelectionBox color={borderColor} desc="Control Publisher & SSP Relationships" name="Independent"
                        caption="Usage-Based SaaS Fee"
                        noInfo={true}
                        className="bb-animate fadeIn"
                        onClick={() => handleClick("independent")} isReady={true} />

                    </>}

                </div>
            </div>
        </>
    )
}
const mapStateToProps = state => ({
    user: state.user,
    userProfile: state.settings.users.userProfile.profile,

});

const mapDispatchToProps = {
    getUserProfile
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Commercials);


